/**************************************************
 * Nombre:       Dialogo_Despacho
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid} from "@mui/material";
import {Delete} from "@mui/icons-material";
import logoRedondo from "../../Recursos/logo_redondo.svg"
import {useFormulario} from "../../Modulo_formularios/Hooks/useFormulario";
import {borrarDoc} from "../../Servicios/BD/borrarDoc";
import Formulario_Colecciones from "../Formularios/Formulario_Colecciones";
import {useCargador} from "../../Modulo_Cargador/Hooks/useCargador";
import {guardarDoc} from "../../Servicios/BD/guardarDoc";
import {subirImagenHostingFile} from "../../Servicios/AlmacenamientoHosting/subirImagenHostingFile";
import {guardarFecha} from "../../Servicios/Local/guardarFecha";
import {subirVideoHostingFile} from "../../Servicios/AlmacenamientoHosting/subirVideoHostingFile";

const Dialogo_Colecciones = ({datos, cerrar, realizado}) => {
    const {
        props,
        obtenerEntidad,
    } = useFormulario({
        valoresDefecto: datos
    })
    const {Cargador, Avisos, iniciarCarga, nuevoAviso, terminar} = useCargador({
        logoRedondo: logoRedondo,
        funcionUno: realizado,
        funcionDos: cerrar,
        key: 'dos'
    })


    const subirDatos = async () => {

        let entidad = await obtenerEntidad()
        entidad.fecha = new Date().getTime()

        iniciarCarga()

        let doxImg = await subirImagenHostingFile(entidad.img)
        entidad.img = doxImg.data
        nuevoAviso({aviso: 'Imagen cargado'})

        let doxVideo = await subirVideoHostingFile(entidad.video)
        entidad.video = doxVideo.data
        nuevoAviso({aviso: 'Video cargado'})

        let dox = await guardarDoc('colecciones', entidad)
        if (dox.res) {
            await guardarFecha()
            terminar({aviso: 'Datos de coleccion subidos'})
        } else {
            terminar({aviso: 'No se subieron los datos, intentelo nuevamente', variante: 'error'})
        }

    }


    const borrar = async () => {
        await borrarDoc('reservas', datos.id)
        terminar({aviso: 'Registro borrado'})
    }


    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{p: 1}}
        >

            <Avisos/>

            <Cargador/>

            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Formulario_Colecciones props={props}/>
            </Grid>


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', marginTop: 3}}>
                <Button
                    onClick={() => subirDatos()}
                >Guardar Datos</Button>
            </Grid>

            {datos && datos.id &&
                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Button
                        onClick={() => borrar()}
                        color={'success'} startIcon={<Delete/>} variant={'text'}>
                        Borrar
                    </Button>
                </Grid>
            }

        </Grid>
    )

}
export default Dialogo_Colecciones